import DefaultAvatar from "./defaultAvatar.png";
import MainImage from "./main-image.png";
import LoginPlaceholder from "./login-placeholder.png";
import QuestionaireImage from "./questionnaire-asset-1.png";
import SubmitImage from "./questionnaire-asset-2.png";
import ScoreImage from "./questionnaire-asset-3.png";
import FeatureAsset1 from "./feature-asset-1.png";
import FeatureAsset2 from "./feature-asset-2.png";
import TestimonialUser1 from "./test_user-1.png";
import ImpactAsset1 from "./impact-asset-1.png";
import SecurityAsset1 from "./security-asset-1.png";
import Logo from "./Logo.png";
const Images = {
  DefaultAvatar,
  MainImage,
  LoginPlaceholder,
  QuestionaireImage,
  ScoreImage,
  SubmitImage,
  FeatureAsset1,
  FeatureAsset2,
  TestimonialUser1,
  ImpactAsset1,
  SecurityAsset1,
  Logo,
};

export { Images };
